import GeneralFiltersSection from './GeneralFiltersSection';

export default GeneralFiltersSection;
